import React from 'react'
import {connect} from 'react-redux'

import 'antd/dist/antd.css'
import {Button, Col, message, Row, Select, Spin, Steps, Typography} from 'antd'
import {withRouter} from 'react-router'

import HttpError from '../../component/base/HttpError'
import {newPiecesBasic} from '../../component/piece/common'
import {URL_PIECES, URL_STATEMENTS_ID} from '../../const'
import axios from "axios";
import StatementStepView1 from "../../component/writer/StatementStepView1";
import {
    getArtistStatementWriter,
    getArtistStatementWriters, patchArtistStatementWriters,
    postArtistStatementWriters
} from "../../api/artistStatementWriter";
import {getEditUrl} from "../../component/Utils";

const {Option} = Select
const {Title, Text} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    artistId: state.user.info.artistId, //artist obj id
    email: state.user.info.email,
    role: state.user.info.role,
    artistNames: state.artist.artistNames
}))
class NewStatementStepper extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            stepperCount: 0,
            actionLoading: false,
        }
        this.CancelToken = axios.CancelToken.source()
        if (!props.new) {
            this.s_id = this.getStatementId()
        }else{
            this.s_id = null
        }
    }

    getStatementId = () => {
        let id = this.props.match.params.id
        if (!id) {
            const locationArry = this.props.location.pathname.split('/')
            id = parseInt(locationArry[locationArry.length - 1])
        }
        return id
    }

    componentDidMount() {
        if(this.s_id) {
            this.setState({
                actionLoading: true
            })
            getArtistStatementWriter(this.s_id).then((res)=>{
                if(this.formRef) {
                    if (res.data) {
                        this.formRef.current?.setFieldsValue(res.data)
                    }else{
                        this.setState({
                            statement: ""
                        })
                        this.formRef.current?.setFieldsValue({
                            wordLimit: "500",
                            language: "English",
                            tone: "formal"
                        })
                    }
                }
            }).catch((e)=>{
                this.formRef.current?.setFieldsValue({
                    wordLimit: "500",
                    language: "English",
                    tone: "formal"
                })
            }).finally(()=>{
                this.setState({actionLoading: false})
            })
        }else{
            this.formRef.current?.setFieldsValue({
                wordLimit: "500",
                language: "English",
                tone: "formal"
            })
        }
    }

    onFinish = (values) => {
        this.setState({actionLoading: true})
        if (!this.props.artistId) {
            message.error("need select an artist first!").then(()=>{})
            return
        }
        postArtistStatementWriters({
            artist: this.props.artistId,
            ...values
        })
            .then(async (response) => {
                message.success('Successfully').then((r) => {})
                const newStatement = response.data['id'];
                this.props.history.push({pathname: getEditUrl(URL_STATEMENTS_ID, newStatement)})
                window.location.reload()
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({actionLoading: false})
        })
    }

    onSave = () => {
        this.setState({actionLoading: true})
        const value = this.formRef.current?.getFieldsValue(true)
        patchArtistStatementWriters(this.s_id, value)
            .then(async (response) => {
                message.success('Successfully').then((r) => {})
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({actionLoading: false})
        })
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.actionLoading}>
                <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col>
                        <Title level={1} style={{marginBottom: 0}}>
                           Art Statement Writer
                        </Title>
                    </Col>
                </Row>
                {this.s_id && (
                    <Row>
                        <Button onClick={this.onSave} style={{marginLeft: 'auto', marginRight: '12%'}} type={'primary'}>
                            Save
                        </Button>
                    </Row>
                )}
                <StatementStepView1
                    formId={newPiecesBasic}
                    formRef={this.formRef}
                    {...this.props}
                    hasStatement={this.s_id}
                    newStatement={!this.s_id}
                    onFinish={this.onFinish}
                />

            </Spin>
        )
    }
}

export default withRouter(NewStatementStepper)
